import React, { useEffect } from "react";
import { FreeplayEvent } from "@freeplay/shared-code";
import { useScrollToTop } from "../components/hooks/scrollToTopHook";
import HomeView from "../views/HomeView";
import { useApplication } from "../contexts/ApplicationContext";
import { useServices } from "../contexts/ServiceContext";

export const HomeController = (): JSX.Element => {
    const { eventsApi } = useServices();
    const { appState, appDispatch } = useApplication();
    const { useFadeIn, activeEvents } = appState;
    const handleEventClicked = (event: FreeplayEvent) => {
        appDispatch({ type: "showEventView", eventId: event.id });
        appDispatch({ type: "setPageTitle", pageTitle: event.name });
    };

    useScrollToTop();

    useEffect(() => {
        appDispatch({ type: "setPageTitle", pageTitle: "HOME" });
        (async () => {
            const events = await eventsApi.getAllActiveEvents();
            appDispatch({ type: "setActiveEvents", events });
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            <HomeView
                currentEvents={activeEvents}
                useFadeIn={useFadeIn}
                handleEvent={handleEventClicked}
                animationComplete={() => appDispatch({ type: "setUseFadeIn", useFadeIn: false })}
            />
        </>
    );
};
